import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  // Phase 27.47 fix — this app is light-mode only. `theme="system"`
  // caused white text on white background when the visitor's OS was
  // in dark mode; Sonner switched to dark styling but our CSS
  // variables never do. Forcing "light" keeps every toast readable.
  useTheme(); // kept to preserve provider warm-up if next-themes gets wired later

  return (
    <Sonner
      theme="light"
      richColors
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: "group toast group-[.toaster]:shadow-lg group-[.toaster]:border",
          title: "group-[.toast]:font-semibold",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
